import BaseModule from "~/vuex/modules/base-module";

let Ports = {...BaseModule};

Ports.state = function () {
    let state = BaseModule.state();

    state.endpoints['all'] = '/api/ports';

    state.lastDate = null;
    state.sort = {};


    return state;
};

export default Ports;
